import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
import delay from 'lodash/delay';
import { mapGetters } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-bottom-doodle.svg';
import { SLOW_TIMER } from '~/const/timers';
import { OLAPIC_URL } from '~/const/3rd';
export default {
  props: {
    olapic: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })),
  mounted: function mounted() {
    var _this = this;

    this.asyncScript(OLAPIC_URL).then(function () {
      delay(_this.onOlapicLoad, SLOW_TIMER);
    }).catch(function (err) {
      console.log(err);
    });
    this.$watch('product', function () {
      _this.onOlapicLoad();
    });
  },
  updated: function updated() {
    this.onOlapicLoad();
  },
  methods: {
    doRender: function doRender(options) {
      window.olapic.prepareWidget(options, {
        renderNow: true,
        force: true
      });
    },
    onOlapicLoad: function onOlapicLoad() {
      var _this2 = this;

      if (window.OlapicSDK) {
        window.OlapicSDK.conf.set('apikey', this.olapic.apikey);
        window.olapic = new window.OlapicSDK.Olapic(function (o) {
          window.olapic = o;

          _this2.doRender({
            id: _this2.olapic.instance,
            wrapper: 'olapic_specific_widget',
            tags: _this2.olapic.mpnCode,
            lang: "".concat(_this2.locale.language, "_").concat(_this2.locale.market),
            useOpi: true
          });
        });
      }
    }
  }
};